import { Text, type TextProps } from 'react-aria-components';
import { cn } from '~/shared/components/utils';
import { fieldMessageStyles } from './util';

export function FieldDescription(props: TextProps) {
	const textProps = typeof props.children === 'string' ? { dangerouslySetInnerHTML: { __html: props.children } } : props;
	return <Text {...textProps} slot="description" className={cn(fieldMessageStyles({ intent: 'description' }), 'mt-1', props.className)} />;
}
